export const DEFAULT_TYPE_MOVIE = "movie";

export const DEFAULT_TYPE_SERIES = "series"
